import soraSemiboldUrl from "@fontsource/sora/files/sora-latin-600-normal.woff";

export const INFO_FONT_URL = soraSemiboldUrl;
